export const setToSessionStorage = (key: string, value?: null | string) => {
  if (typeof window === 'undefined' || !sessionStorage) {
    return null;
  }

  try {
    if (value) {
      sessionStorage.setItem(key, value);
    } else {
      sessionStorage.removeItem(key);
    }
  } catch {
    console.error(`Failed to set ${key} in sessionStorage`);
  }
};
